export type PortfolioVideo = {
  src: string;
  title: string;
  subtitle?: string;
  poster: string;
  // Tailwind grid span used by PortfolioSection
  span: string;
};

export const heroVideo = {
  src: "https://media.stroyflagman.com/flagman-hero_min.mp4",
  poster: "/media/photos/hero_1-768.webp",
  alt: "Промо-видео Флагман Строй",
} as const;

export const portfolioVideos: readonly PortfolioVideo[] = [
  {
    src: "https://media.stroyflagman.com/1.mp4",
    poster: "/media/photos/hero_1-768.webp",
    title: "Полусухая стяжка",
    subtitle: "Быстро и качественно",
    span: "col-span-2 row-span-2",
  },
  {
    src: "https://media.stroyflagman.com/2.mp4",
    poster: "/media/photos/plastering/plastering_1-768.webp",
    title: "Механизированная штукатурка",
    span: "",
  },
  {
    src: "https://media.stroyflagman.com/3.mp4",
    poster: "/media/photos/plastering/plastering_2-768.webp",
    title: "Жилой комплекс",
    span: "",
  },
  {
    src: "https://media.stroyflagman.com/4.mp4",
    poster: "/media/photos/plastering/plastering_4-768.webp",
    title: "Частный дом",
    span: "",
  },
  {
    src: "https://media.stroyflagman.com/5.mp4",
    poster: "/media/photos/plastering/plastering_6-768.webp",
    title: "Идеальная ровность",
    span: "",
  },
] as const;
